/**************************************************
 * Nombre:       Tarjeta_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {theme} from "../../Tema";
import {useNavigate} from "react-router";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../App";
import {valorConDescuento} from "../../CodCliente/valorConDescuento";
import {obtenerPorcentaje} from "../../CodCliente/obtenerPorcentaje";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";

const Tarjeta_Producto = ({item}) => {
    const cData = useContext(contexApp)
    const navigate = useNavigate()
    const {sCell, masSM} = useResponsive()
    const [esBlack, setEsBlack] = useState(false)
    const [contenido, setContenido] = useState(item)

    useEffect(() => {

        if (cData.configuraciones?.black === 'Si') {
            setEsBlack(true)
        } else {
            setEsBlack(false)
        }

        obtenerDoc('productos', item.id).then((dox) => {
            if (dox.res && dox.data) {
                setContenido(dox.data)
            }
        })

    }, [cData, item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: theme.palette.primary.main}}
        >

            {(esBlack || contenido.rebajado > 0) &&

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mb: -4, mt: 2, zIndex: 2}}>
                    <Typography sx={{
                        backgroundColor: '#000',
                        color: '#fff',
                        px: 1,
                        fontSize: 12,
                        fontWeight: 400,
                        borderBottomRightRadius: 6,
                        borderTopRightRadius: 6
                    }}>
                        {contenido.rebajado > 0 ?
                            '-' + obtenerPorcentaje({valor: contenido.valor, rebajado: contenido.rebajado}) + '%'
                            :
                            '-20% Black Days'

                        }

                    </Typography>
                </Grid>

            }

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{border: 1, borderColor: theme.palette.primary.main, zIndex: 1}}>
                <Zoom>
                    <img src={item.img} width={'100%'} height={'auto'}
                         style={{border: 1, borderColor: theme.palette.primary.main}}/>
                </Zoom>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontWeight: 600, textAlign: 'center', lineHeight: 1.1}}>{contenido.nombre}</Typography>
            </Grid>


            {(esBlack || contenido.rebajado > 0) ?

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{px: 1}}
                >


                    <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 1, px: 0}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 12, lineHeight: 1.1}}>Antes</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{
                                    fontSize: 14,
                                    lineHeight: 1.1,
                                    textDecoration: 'line-through'
                                }}>{formatoMoneda(contenido.valor)}</Typography>
                            </Grid>

                        </Grid>

                    </Grid>

                    <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 1, px: 0}}>
                        <Grid
                            container
                            justifyContent={'flex-end'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                                <Typography sx={{fontSize: 12, lineHeight: 1.1, fontWeight: 800}}>Ahora</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                                <Typography sx={{
                                    fontSize: 14,
                                    lineHeight: 1.1,
                                    fontWeight: 800
                                }}>
                                    {contenido.rebajado > 0 ?
                                        formatoMoneda(contenido.rebajado)
                                        :
                                        formatoMoneda(valorConDescuento({valor: contenido.valor, descuento: 20}))
                                    }

                                </Typography>
                            </Grid>

                        </Grid>

                    </Grid>

                </Grid>

                :

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                    <Typography sx={{
                        fontSize: 14,
                        lineHeight: 1.1,
                    }}>{formatoMoneda(contenido.valor)}</Typography>
                </Grid>


            }
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Button
                    onClick={() => navigate('/Detalle/' + contenido.id)}
                    sx={{px: !masSM ? 2 : 4}}
                    variant={'outlined'}>Ver Detalle</Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Producto